<div class="flex flex-column" style="max-height: 550px">
    <div
        class="flex flex-column pb-0 w-full border-bottom-1 bg-white surface-border"
        style="position: sticky; top: -2px; z-index: 1"
    >
        <p class="mb-0">
            As a premium+ member, we'll prioritize finding deals to your dream
            destinations and also send you SMS alerts so you never miss your
            dream deal.
        </p>
        <search-select
            #searchBox
            placeholder="Search Cities, States or Countries"
            [currentCount]="destinations.length"
            [maxCount]="maxCount"
            [existingIds]="destinations"
            [resultCap]="4"
            [searchFn]="searchDestinations"
            [idKey]="'id'"
            itemLabelSingular="destination"
            [showUpgradeModalOnLimit]="user?.isFree"
            (added)="onAddDestination($event)"
            (limitReached)="openUpgradeModal()"
        >
        </search-select>
    </div>

    <div
        class="overflow-auto"
        style="flex: 1; min-height: 0"
    >
        <div class="grid grid-nogutter pt-4">
            <div
                class="col-6 p-2"
                *ngFor="let destination of destinations; trackBy: trackByDestId" (mouseenter)="hoveredDestinationId = destination.id"
                (mouseleave)="hoveredDestinationId = null"
            >
                <div class="relative">
                    <div
                        class="w-full"
                        style="
                            position: relative;
                            padding-top: 100%;
                            border-radius: var(--border-radius);
                            overflow: hidden;
                        "
                    >
                        <img
                            [src]="destination.images[0].urlOriginal"
                            style="
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            "
                        />
                    </div>

                    <p-tag
                        severity="success"
                        [rounded]="true"
                        styleClass="absolute top-0 right-0 mt-3 mr-3"
                        [style]="{ width: '22.75px', height: '22.75px' }"
                        (click)="removeDestination(destination)"
                    >
                        <i
                            class="cursor-pointer"
                            [ngClass]="hoveredDestinationId === destination.id
            ? 'ph ph-x text-black text-lg'
            : 'ph-fill ph-heart text-red-500 text-lg'"
                        ></i>
                    </p-tag>


                </div>
                <div class="flex flex-column gap-2 mt-2">
                    <h6 class="m-0">{{ destination.name }}<span *ngIf="destination.stateName">, {{destination.stateName}}</span> </h6>
                    <h6
                        class="m-0 font-normal white-space-nowrap overflow-hidden text-overflow-ellipsis"
                    >
                        {{ destination.country.name }}
                    </h6>
                </div>
            </div>
            <div
                class="col-6 p-2 cursor-pointer"
                *ngIf="destinations.length < maxCount || user?.isFree"
                (click)="handleAddDestinationClick()"
            >
                <div class="relative">
                    <div
                        class="w-full surface-200 flex justify-content-center align-items-center relative"
                        style="aspect-ratio: 1; border-radius: var(--border-radius); overflow: hidden;"
                    >
                        <i class="ph ph-plus text-8xl text-white"></i>
                    </div>
                </div>
                <div class="flex flex-column gap-2 mt-2">
                    <h6 class="m-0">Add new destination</h6>
                </div>
            </div>
        </div>
    </div>
</div>
